module.exports = __webpack_public_path__ + "img/bg.83de30bf.jpg";